var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formRef",
      staticClass: "company-info_form",
      attrs: {
        model: _vm.form,
        "label-width": "120px",
        "label-position": _vm.getIsMobile ? "top" : "right",
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公司名" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请选择公司名",
                      type: "text",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.dscompany,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dscompany", $$v)
                      },
                      expression: "form.dscompany",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "接受人" } },
                [
                  _c(
                    "el-input",
                    {
                      ref: "inputRef",
                      attrs: {
                        placeholder: "请选择接受人",
                        type: "text",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.dsname,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "dsname", $$v)
                        },
                        expression: "form.dsname",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "prepend" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.handleContact.apply(null, arguments)
                            },
                          },
                          slot: "prepend",
                        },
                        [_vm._v("请选择")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入部门", type: "text" },
                    model: {
                      value: _vm.form.dsbumen,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dsbumen", $$v)
                      },
                      expression: "form.dsbumen",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开户银行" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入开户银行", type: "text" },
                    model: {
                      value: _vm.form.dsbank,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dsbank", $$v)
                      },
                      expression: "form.dsbank",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "电话" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入电话", type: "text" },
                    model: {
                      value: _vm.form.dstel,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dstel", $$v)
                      },
                      expression: "form.dstel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号", type: "text" },
                    model: {
                      value: _vm.form.dsphone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dsphone", $$v)
                      },
                      expression: "form.dsphone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "账号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入账号", type: "text" },
                    model: {
                      value: _vm.form.dsbanknum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dsbanknum", $$v)
                      },
                      expression: "form.dsbanknum",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "传真" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入传真", type: "text" },
                    model: {
                      value: _vm.form.dsmax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dsmax", $$v)
                      },
                      expression: "form.dsmax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入邮箱", type: "text" },
                    model: {
                      value: _vm.form.dsemail,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dsemail", $$v)
                      },
                      expression: "form.dsemail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "税号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入税号", type: "text" },
                    model: {
                      value: _vm.form.dskpsbnum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dskpsbnum", $$v)
                      },
                      expression: "form.dskpsbnum",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }